export default "__VITE_ASSET__CiVP651M__"